const selectSpaceSelector = (state) => ({
  ...state,
  openTimestamp: null,
  openCorrelationId: null,
});

export default selectSpaceSelector;
